import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
  };

  return (
    <div className="flex items-center gap-2 border border-black px-3 py-2 bg-white">
      <Globe size={16} className="text-black" />
      <select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="bg-white text-black font-mono text-sm border-none outline-none cursor-pointer"
      >
        <option value="en">English</option>
        <option value="th">ไทย</option>
      </select>
    </div>
  );
}
